export interface ISegmentFolderInput {
  id?: number;
  title: string;
  communityId?: number;
  programId?: number;
  sourceGroup?: string;
}
